// extracted by mini-css-extract-plugin
export default {"title":"CardDescription_title__NBnGs","wrapper":"CardDescription_wrapper__mZFhX"};